import { render } from "./StudentList.vue?vue&type=template&id=6f54a0ee&scoped=true&ts=true"
import script from "./StudentList.vue?vue&type=script&lang=ts"
export * from "./StudentList.vue?vue&type=script&lang=ts"

import "./StudentList.vue?vue&type=style&index=0&id=6f54a0ee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f54a0ee"]])

export default __exports__